import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hm-hero">

      <div className="hm-hero-container">

        {/* LEFT CONTENT */}
        <div className="hm-hero-content">

          <div className="hm-hero-small-title">
            WATERPROOF ADHESIVE
          </div>

          <h1 className="hm-hero-title">
            Precision bond
            <br />
            <span>for every craft &amp; repair.</span>
          </h1>

          <p className="hm-hero-description">
            Industrial-grade multi-purpose clear adhesive with precision needle tip,
            formulated for smartphones, crafts, jewelry, leather &amp; electronics.
          </p>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/919727983039"
            className="hm-whatsapp-btn"
            target="_blank"
            rel="noreferrer"
          >
            <svg
              viewBox="0 0 24 24"
              className="hm-whatsapp-icon"
            >
              <path
                fill="currentColor"
                d="M20.52 3.48A11.82 11.82 0 0 0 12.06 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.15 1.6 5.96L.06 24l6.28-1.65a11.88 11.88 0 0 0 5.72 1.46h.01c6.56 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.17-3.45-8.43ZM12.07 21.8a9.86 9.86 0 0 1-5.03-1.38l-.36-.22-3.73.98 1-3.64-.23-.37a9.82 9.82 0 1 1 8.35 4.63Zm5.4-7.36c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.09 4.49.71.31 1.26.49 1.69.63.71.23 1.35.2 1.86.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z"
              />
            </svg>

            Chat with us
          </a>

          {/* STATS */}
          <div className="hm-stats">

            <div className="hm-stat">
              <strong>5</strong>
              <span>Product views</span>
            </div>

            <div className="hm-stat">
              <strong>15 in</strong>
              <span>Organized living</span>
            </div>

            <div className="hm-stat">
              <strong>100%</strong>
              <span>Foldable design</span>
            </div>

          </div>

        </div>


        {/* RIGHT PRODUCT */}
        <div className="hm-hero-product">

          <div className="hm-product-image-box">

            <img
              src="/images/slider.webp"
              alt="Storage Organizer"
              className="hm-product-image"
            />

          </div>


          {/* Floating Card */}
          <div className="hm-product-card">

            <div className="hm-card-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
              >
                <path d="M20 11a8.1 8.1 0 0 0-15.9-2M4 5v4h4" />
                <path d="M4 13a8.1 8.1 0 0 0 15.9 2M20 19v-4h-4" />
              </svg>
            </div>

            <div>
              <strong>Easy-access lid</strong>
              <span>Open, sort and store</span>
            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default Hero;